import React from 'react';
import { twMerge } from 'tailwind-merge';
import { cleanMessagePreview } from '@ui/lib/utils';

interface RepliedMessageBubbleProps {
  username: string;
  message: string;
  isOwnMessage?: boolean;
  onPress?: () => void;
}

export const RepliedMessageBubble: React.FC<RepliedMessageBubbleProps> = ({
  username,
  message,
  isOwnMessage = false,
  onPress,
}) => {
  // Strip all markup first, then truncate (so we never cut a tag mid-way).
  const cleanedMessage = cleanMessagePreview(message);
  const truncatedMessage =
    cleanedMessage.length > 100 ? `${cleanedMessage.substring(0, 100)}...` : cleanedMessage;

  const baseClasses = twMerge(
    'border-l-4 pl-2 py-2 pr-2 mb-2 rounded-r-md',
    isOwnMessage ? 'border-orange-500 bg-orange-50' : 'border-blue-500 bg-blue-50',
    onPress ? 'cursor-pointer hover:opacity-80 transition-opacity' : '',
  );

  const handleClick = () => {
    if (onPress) {
      onPress();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (onPress && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onPress();
    }
  };

  return (
    <div
      className={baseClasses}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={onPress ? 'button' : undefined}
      tabIndex={onPress ? 0 : undefined}
      data-ignore-tap="true">
      <p className="text-xs font-semibold text-gray-700 truncate">{username}</p>
      <p className="text-xs text-gray-600 mt-1 line-clamp-2">{truncatedMessage}</p>
    </div>
  );
};
